export default {"src":"/_next/static/media/loading.73a69bd0.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};